import { svg, type TemplateResult } from "lit";

import type {
  AlertPalette,
  AlertStatus,
  AlertVariant,
  SbAlertProps,
} from "./alert.types";

export const ALERT_ICON_FRAGMENTS: Record<AlertStatus, TemplateResult<2>> = {
  default: svg`
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" x2="12" y1="8" y2="12"/>
    <line x1="12" x2="12.01" y1="16" y2="16"/>
  `,
  error: svg`
    <circle cx="12" cy="12" r="10"/>
    <path d="m15 9-6 6"/>
    <path d="m9 9 6 6"/>
  `,
  warning: svg`
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" x2="12" y1="8" y2="12"/>
    <line x1="12" x2="12.01" y1="16" y2="16"/>
  `,
  success: svg`
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  `,
  info: svg`
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 16v-4"/>
    <path d="M12 8h.01"/>
  `,
};

/* ------------------------------------------------------------ */

export const DEFAULT_ALERT_PROPS: Omit<SbAlertProps, "seed" | "title"> = {
  status: "default",
  palette: "default",
  variant: "default",
};

/* ------------------------------------------------------------ */

const STATUSES_REC: Record<AlertStatus, AlertStatus> = {
  default: "default",
  error: "error",
  warning: "warning",
  success: "success",
  info: "info",
};

const PALETTES_REC: Record<AlertPalette, AlertPalette> = {
  default: "default",
  base: "base",
  brand: "brand",
};

const VARIANTS_REC: Record<AlertVariant, AlertVariant> = {
  default: "default",
  tonal: "tonal",
  outline: "outline",
};

/* ---------------------------------------- */

export const ALERT_STATUSES: AlertStatus[] = Object.values(STATUSES_REC);
export const ALERT_PALETTES: AlertPalette[] = Object.values(PALETTES_REC);
export const ALERT_VARIANTS: AlertVariant[] = Object.values(VARIANTS_REC);
